import { UserAddressDTO } from './user-address'

export interface OrganizationDTO {
  id: number
  externalId: string
  name: string
  children: OrganizationDTO[]
}

export enum Sex {
  MALE = 'MALE',
  FEMALE = 'FEMALE'
}

export enum UserRoleName {
  SUPER_ADMIN = 'SUPER_ADMIN',
  STORE_ADMIN = 'STORE_ADMIN',
  SALES_ASSISTANT = 'SALES_ASSISTANT',
  VIEWER = 'VIEWER'
}

export interface UserRoleDTO {
  id: number
  label: string
  name: UserRoleName
  permissions: any
  priority: number
}

export interface UserDTO {
  addresses: UserAddressDTO[]
  changePasswordCode: string
  created: string
  createdBy: UserDTO
  currency: string
  dateOfBirth: string
  emailAddress: string
  externalId: string
  firstName: string
  id: number
  imageUrl: string
  language: string
  lastName: string
  marketplaceId: number
  organizations: OrganizationDTO[]
  phoneNumber: string
  roles: UserRoleDTO[]
  role: UserRoleDTO
  sex: Sex
}
